import { PRODUCT_ASSETS_URL } from "@futrli/ui-components/ui-styles/ts/base/image-urls";

function handleBrowserColorMode(e: any) { // eslint-disable-line @typescript-eslint/no-explicit-any
  const darkModeEnabled = e?.matches;
  const favicon: HTMLLinkElement|null = document.querySelector('link[rel="icon"][class="js-favicon"]');
  const svgFavicon: HTMLLinkElement|null = document.querySelector('link[rel="icon"][class="js-favicon"][type="image/svg+xml"]');

  if (favicon) {
    favicon.href = darkModeEnabled
      ? `${PRODUCT_ASSETS_URL}favicon/icon-32-dark-mode.png`
      : `${PRODUCT_ASSETS_URL}favicon/icon-32.png`;
  }

  if (!svgFavicon) {
    return;
  }

  // If the browser mode changes, we need to reload the svg image
  // to get the svg detecting the "prefers-color-scheme" change.
  svgFavicon.href =  `${PRODUCT_ASSETS_URL}favicon/icon.svg`;
}

export const initBrowserColorModeListener = () => {
  const darkModeMediaQuery = window.matchMedia('(prefers-color-scheme: dark)');

  handleBrowserColorMode(darkModeMediaQuery);
  darkModeMediaQuery.addEventListener('change', handleBrowserColorMode);
}
